import { SheetModal } from '@/components/SheetModal';
import { StructuredSlideOutContent } from '@/features/underwriting-eligibility/components/structured-slide-out-content';
import { mapRunResultToStructured } from '@/features/wizard-evals/utils/mapRunResultToStructured';
import type { WizardEvalRunResult } from '@/features/wizard-evals/api/wizard-evals-api';

interface RunOutputSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  result: WizardEvalRunResult;
  title?: string;
}

export function RunOutputSheet({
  open,
  onOpenChange,
  result,
  title = 'Waterlily Underwriting Analysis',
}: RunOutputSheetProps) {
  const { structuredResult, pipelineMetadata } = mapRunResultToStructured(result);

  return (
    <SheetModal
      open={open}
      onClose={() => onOpenChange(false)}
      title={title}
      subTitle=""
      className="sm:min-w-[85%] md:min-w-[600px] lg:min-w-[700px]"
    >
      <div className="pb-8 pt-3 text-gray-800">
        {structuredResult ? (
          <StructuredSlideOutContent
            structuredResult={structuredResult}
            pipelineMetadata={pipelineMetadata}
          />
        ) : (
          <p className="text-sm text-gray-600">
            No structured output available for this run.
          </p>
        )}
      </div>
    </SheetModal>
  );
}
